import { motion, useScroll, useSpring } from "framer-motion";
import { cn } from "../../utils/classnames";

/**
 * Thin gold bar that fills as the user scrolls through a long box of text
 * (terms & conditions, memorandum…).
 *
 * Put it inside a `relative` parent that also contains the scrolling element,
 * and pass that element's ref:
 *
 *   <div className="tw:relative tw:overflow-hidden">
 *     <ScrollProgressBar containerRef={scrollBoxRef} />
 *     <div ref={scrollBoxRef} className="tw:overflow-y-auto">…</div>
 *   </div>
 */
const ScrollProgressBar = ({ containerRef, className }) => {
    // layoutEffect: false — wait until refs are attached. The bar is rendered
    // before the scroll box, so in a layout effect the box's ref is still empty
    // and framer would track the whole page's scroll instead of the box.
    const { scrollYProgress } = useScroll({ container: containerRef, layoutEffect: false });
    // Spring-smoothed so the bar glides instead of jumping with each wheel tick.
    const smoothProgress = useSpring(scrollYProgress, { stiffness: 220, damping: 32, mass: 0.4 });

    return (
        <motion.div
            className={cn(
                "tw:absolute tw:inset-x-0 tw:top-0 tw:z-10 tw:h-[3px] tw:origin-left tw:bg-[#DBBE78]",
                className
            )}
            style={{ scaleX: smoothProgress }}
            aria-hidden="true"
        />
    );
};

export default ScrollProgressBar;
